export enum SURVEY_STATUS {
  DRAFT = 'DRAFT',
  SCHEDULED = 'SCHEDULED',
  ACTIVE = 'ACTIVE',
  CLOSED = 'CLOSED',
  PUBLISHED = 'PUBLISHED',
}

export enum QuestionType {
  YES_NO = 'YESNO',
  MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
  SINGLE_CHOICE = 'SINGLE_CHOICE',
  SCALE = 'SCALE',
  FREE_TEXT = 'TEXT',
}

export enum RESULTS_SUMMARY {
  ACTIVITY = 'ACTIVITY',
  GENDER = 'GENDER',
  AGE = 'AGE',
}
